var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-nav" }, [
    !_vm.opened
      ? _c("div", { staticClass: "main-menu" }, [
          _c(
            "div",
            {
              staticClass: "item-block",
              on: {
                click: function ($event) {
                  return _vm.showSection("tdb-dealroom")
                },
              },
            },
            [
              _c("menu-item", {
                attrs: {
                  text: "TDB Deal Room",
                  caption: "Great funding opportunities for African businesses",
                },
              }),
              _vm._v(" "),
              _c("arrow-right"),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.opened
      ? _c(
          "div",
          { staticClass: "nav-details" },
          [
            _c(
              "div",
              { staticClass: "details-header" },
              [
                _c("arrow-left", { on: { click: _vm.showMainMenu } }),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.selectedTitle))]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.opened === "tdb-dealroom"
              ? _c("tdb-dealroom-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.hide,
                      expression: "hide",
                    },
                  ],
                  staticClass: "opened-menu",
                  on: { hide: _vm.hide },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }